/** Created by azhou on 2019/2/26.*/
<template>
  <div>
    <!-- <public-title>订单列表{{OrderLists.user_list}}</public-title> -->
    <div class="load-areas">
      <div class="toptab">
        <div class="d-end-start">
          <!-- <el-select v-model="orderType" placeholder="请选择订单类型" class="select-type" v-if="showSelectType">
            <el-option v-for="item in orderTypes" :key="item.name" :value="item.type" :label="`${item.name} ${item.num}`">
              {{item.name}}&nbsp;<span class="text-red">{{item.num}}</span>
            </el-option>
          </el-select> -->
          <el-tabs v-model="orderStatus" type="card" >
            <el-tab-pane :name="item.status" v-for="item in tabArr" :key="item.title+orderType" >
              <label slot="label" :class="item.values" class="cursor">
                <i class="el-icon-delete" v-if="item.title=='订单回收站'"></i>
                {{item.title}}
                <span class="text-muted grey" :class="item.value" v-if="OrderNum(item) > 0">({{OrderNum(item)}})</span>
                <span class="unread-msg grey" :class="item.value" v-if="showUnread(item) > 0">{{showUnread(item)}}</span>
              </label>
            </el-tab-pane>
          </el-tabs>
          <el-select v-model="user_list" placeholder="请选择人员" class="card" v-if="userInfo.type===2&&isGroup">
            <el-option v-for="item in Userlist" :key="item.uid" :value="item.uid" :label="`人员：${item.truename}`">
              {{item.truename}}
            </el-option>
          </el-select>
          <el-select v-model="Hote_list" placeholder="请选择酒店" class="card" v-if="userInfo.type===3&&isGroup">
            <el-option v-for="item in Hotellist" :key="item.uid" :value="item.uid" :label="`销售人员：${item.truename}`">
              {{item.truename}}
            </el-option>
          </el-select>
          <el-tabs v-model="orderStatus" type="card" @tab-click='handleClick' v-if="!isGroup">
            <template v-for="item in recovery">
            <el-tab-pane :name="item.status"  :key="item.title+orderType" v-if="orderStatus!=66">
              <label slot="label" :class="item.values" >
                <i class="el-icon-delete" v-if="item.title=='订单回收站'"></i>
                {{item.title}}
              </label>
            </el-tab-pane>
            </template>
            <el-tab-pane name="66" v-if="orderStatus==66">
              <label slot="label" class="66">
                <i class="el-icon-delete" ></i>
                回到订单列表
              </label>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!--搜索-->
        <search-con class="mop-none" :orderType="orderType" @getSearchCon="getSearchCon"/>
      </div>
      <div v-if="orderType===3" class="mt-4">
        <ul class="list-head tablie">
          <li :class="item.w" v-for="item in titleArr" :key="item.title">
            <img class="img-i" 
            img :src="'/images/public/sj-'+Sorts+'.png'" 
            v-if="item.title=='需求/报价/人数'"
            @click="Sort"
            >
            <span>{{item.title}}</span>
          </li>
        </ul>
        <p class="jzk" v-loading="loading" v-if="loading"></p>
        <div v-if="orderStatus=='66'" class="delete">
          <el-checkbox  v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <p @click="batchDelOrderHotel">批量永久删除</p>
          <p @click="batchRestoreOrders">批量还原</p>
        </div>
          <el-checkbox-group v-model="hoid_list" @change="handleCheckedCitiesChange" v-if="!loading">
            <div v-for="(item,index) in OrderLists" :key="index+1">
              <hotel-order-itemize 
              :cardItem="item"
              :orderStatus ='orderStatus'
              :class="{'bg-base':showDetailIndex === index}"
              @goForDetail="goForDetail" 
              @getOrderList="getOrderList"
              @getOrderFlag="getOrderFlag"
              @showDetail="showDetail(item,index)">
                <el-checkbox  v-if="orderStatus=='66'" :label="item.oid" :key="item.oid" >{{item.sss}}</el-checkbox>
              </hotel-order-itemize>
              <!-- <transition name="fade">
                <hotel-order-card v-show="showDetailIndex === index" @getOrderList="getOrderList"/>
              </transition> -->
            </div>
          </el-checkbox-group>
      </div>
      <div v-if="orderType===5">
        <ul class="list-head"><li class="w-50" v-for="item in titleMArr" :key="item">{{item}}</li></ul>
        <homestay-order-card :cardItem="item" @goForDetail="goForDetail"
                            v-for="(item,index) in OrderLists" :key="index+1"/>
      </div>
      <div v-if="orderType===6">
        <ul class="list-head"><li class="w-50" v-for="item in titleSArr" :key="item">{{item}}</li></ul>
        <scenic-order-card :cardItem="item" @goForDetail="goForDetail"
                          v-for="(item,index) in OrderLists" :key="index+1"/>
      </div>
      <div v-if="orderType===7">
        <vocation-order-itemize @goForDetail="goForDetail"/>
      </div>
      <div v-if="orderType == 8">
        <ul class="list-head mt-2">
          <li :class="item.w" v-for="item in titleBArr" :key="item.title">{{item.title}}</li>
        </ul>
        <brand-order-card :cardItem="item" @goForDetail="goForDetail"
                          v-for="(item,index) in OrderLists" :key="index+1" />
      </div>
      <div v-if="orderType===1">
        <year-card :cardItem="item" @goForDetail="goForDetail"
                   v-for="(item,index) in OrderLists" :key="index+1"/>
      </div>
      <p class="mt-3" v-if="OrderLists.length<=0&&!loading">未查询到数据</p>
      <el-pagination background layout="prev, pager, next" class="mt-4 pagination" v-if="Number(TotalOrder) > 0&&!loading"
        :total="Number(TotalOrder)" :current-page="Number(queryCon.page)"                     
      @current-change="$GFUN.pageChange"/>
    </div>
    <el-dialog title="标记" :visible.sync="showConfirmPanel" width="50%" center id="loadConfirm">
      <HotelOrderIFlag :flagtiem='flagtiem' :flagtype='flagtype' @getOrderList="getOrderList" @firmPanel="showConfirmPanel=!showConfirmPanel" v-if="showConfirmPanel"/>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
  import HotelOrderItemize from './HotelOrderItemize'
  import VocationOrderItemize from './VocationOrderItemize'
  import HomestayOrderCard from './HomestayOrderCard'
  import HotelOrderIFlag from './HotelOrderIFlag'
  import ScenicOrderCard from './ScenicOrderCard'
  import SearchCon from './SearchCon'
  import YearCard from './YearCard'
  import HotelOrderCard from './HotelOrderCard'
  import BrandOrderCard from './BrandOrderCard'
  import _ from 'lodash'
  import { debounce } from "lodash";
  export default {
    name: 'Index',
    components: {
      HotelOrderCard,
      YearCard,
      SearchCon,
      ScenicOrderCard,
      HomestayOrderCard,
      HotelOrderItemize,
      VocationOrderItemize,
      BrandOrderCard,
      HotelOrderIFlag
    },
    data() {
      return {
        flagtiem:[],
        showConfirmPanel:false,
        orderType: 3,
        orderStatus: 'all',
        cardItem: {},
        showDetailIndex: '',
        searchCon: null,            //搜索条件
        src:1,
        user_list:0,
        Hote_list:0,
        recovery:[
          {title: '订单回收站', status:'66'},
        ],
        Sorts:0,
        flagtype:'',
        hoid_list:[],
        checkAll: false,
        isIndeterminate: true,
        loading:false,
      }
    },
    mounted() {
      //采购商和管理员通过路由确定订单类型，酒店、民宿、景区通过身份确定订单类型
      if (this.queryCon.orderType) this.orderType = Number(this.queryCon.orderType);
      if (this.queryCon.orderStatus) this.orderStatus = this.queryCon.orderStatus;
      // 通过身份改变了orderType会触发一次拉取订单列表
      if (this.$GFUN.isInArray([3, 5, 6, 8], this.userInfo.type)) {
        let query = {...this.queryCon, orderType: this.userInfo.type};
        this.orderType = this.userInfo.type;
        this.$router.push({name: this.$route.name, query})
      }
      //已支付筛选
      if(this.$route.query.pay_flag){
         this.searchCon={
          pay_flag:this.$route.query.pay_flag,
        }
      }
      this.user_list='0';
      if(this.isGroup){
        this.orderStatus='7';
      }
      // //获取订单列表
      // this.getOrderList();
      //获取相应状态的订单总数
      // if(this.userInfo.type===3){
      //   this.getOrderNumInfo(this.userLoginMessage);
      // }
    },
    watch: {
      queryCon() {
        this.showDetailIndex = '';
      },
      user_list(){
        this.loading = true;
        this.getOrderList();
        this.getOrderNumInfo({
          listID:this.storeInfo.type===3?this.Hote_list:this.user_list,
        });
      },
      Hote_list(){
        this.loading = true;
        this.getOrderNumInfo({
          listID:this.Hote_list
        });
        this.getOrderList();
      },
      'queryCon.page': 'getOrderList',
      'queryCon.orderType'(newVal) {
        if (newVal) {
          this.searchCon = null;
          this.orderType = Number(newVal);
          if (this.$GFUN.isInArray([3, 5, 6, 8], this.userInfo.type)) {
            let query = {...this.queryCon, orderType: this.userInfo.type,pay_flag:''};
            this.orderType = this.userInfo.type;
            this.$router.push({name: this.$route.name, query})
          }
          this.loading = true;
          this.getOrderList();
        }
      },
      'queryCon.orderStatus'(newVal) {
        this.loading = true;
        console.log(newVal,'切换')
        if (newVal) {
          this.searchCon = null;
          this.orderStatus = newVal;
          this.getOrderList();
        }
      },
      orderType(newVal) {
        //只有当身份不为3,5,6,8时，才监控orderType的变化并重新拉取订单
        if (!this.$GFUN.isInArray([2,3, 5, 6, 8], this.userInfo.type)) {
          let query = {...this.queryCon, page: 1, orderType: newVal, orderStatus: 'all'};
          this.$router.push({name: this.$route.name, query})
        }
        //获取相应状态的订单总数
        // this.getOrderNumInfo(this.orderType);
        this.getOrderNumInfo({
          listID:this.storeInfo.type===3?this.Hote_list:this.user_list
        });
      },
      orderStatus:_.debounce(function(newVal) {
        let query = {...this.queryCon, page: 1, orderStatus: newVal};
        delete  query.pay_flag;
        this.$router.push({name: this.$route.name, query})
      },200),
      newMessageInform(newVal) {
        //付钱成功时刷新个订单状态数值
        if (newVal && (newVal.type === 12 || newVal.type === 32 || newVal.type == 35)) {
          this.getOrderNumInfo({
            listID:this.storeInfo.type===3?this.Hote_list:this.user_list
          });
          // this.getOrderNumInfo(this.orderType);
          this.getWaitHandleData();
          this.loading = true;
          this.getOrderList();
        }
        //有新订单状态变更
        let refreshArr = ['25', '4', '30', '6', '8'];
        if (this.$GFUN.isInArray(refreshArr, newVal.type))this.getOrderNumInfo({
          num:this.storeInfo.type===3?this.Hote_list:this.user_list
        });
      },
    },
    computed: {
      ...mapState(['userHeadInfo','userLoginMessage','Userlist','Hotellist','OrderLists', 'TotalOrder', 'currentStoreInfo', 'HotterOfferLists', 'OrderDetail', 'waitVerify', 'IndexData', 'OrderNumInfo', 'newMessageInform']),
      ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),
      queryCon() {      //使用路由来记录的页数和订单类型、订单状态
        return this.$route.query
      },
      showSelectType() {    //是否显示选择订单类型
        let t = this.storeInfo.type;
        return t === 2 || t === 99;
      },
      orderTypes() {
        return [
          {type: 3, name: '住宿订单', num: this.waitVerify.orderHotel || ''},
          {type: 5, name: '民宿订单', num: this.waitVerify.orderHomestay || ''},
          {type: 6, name: '景区订单', num: this.waitVerify.orderScenic || ''},
          {type: 7, name: '度假产品订单', num:this.waitVerify.vocation || ''},
          {type: 8, name: '品牌馆订单', num:this.waitVerify.orderBrand || ''},
          //{type: 1, name: '年卡订单', num: this.waitVerify.orderYearcard || ''}
        ];
      },
      tabArr() {
        switch (this.storeInfo.type) {
          case 2:
            //集团订单
            if(this.isGroup){
              return [
                  {title: '待入住', status: '7',value:'Orange'},
                  {title: '已入住', status: '8'},
                  {title: '完成', status: '9'},
                  {title: '今日入住', status: 'today',value:'green'},
                ]
              }
              return [
                {title: '全部', status: 'all'},
                {title: '今日入住', status: 'today',value:'green'},
                {title: '入住中', status: 'stay',value:'green'},
                // {title: '询价中', status: '4', value:'red'},
                {title: '待入住', status: '7',value:'Orange'},
                {title: '已入住', status: '8'},
                {title: '完成', status: '9'},
                {title: '取消',status: '99'},

              ]
          case 99:
            switch (this.orderType) { 
              case 3:
                return [
                  {title: '全部', status: 'all'}, 
                  {title: '今日入住', status: 'today',value:'green'},
                  {title: '入住中', status: 'stay',value:'green'},
                  // {title: '询价中', status: '4',value:'red'}, 
                  {title: '待入住', status: '7',value:'Orange'},
                  {title: '已入住', status: '8'},
                  {title: '完成', status: '9'}, 
                  {title: '取消',status: '99'}, 
                ]
              case 5:
              case 8:
                return [{title: '全部', status: 'all'}, {title: '待确认', status: '14'},{title: '已入住', status: '8'},{title: '完成', status: '9'}, 
                {title: '完成', status: '9'}, {title: '取消', status: '98,99,100'},{title: '今日入住', status: 'today',value:'green'},
                {title: '入住中', status: 'stay',value:'green'},]
              case 6:
                return [{title: '全部', status: 'all'}, {title: '待付款', status: '8,21'}, {title: '待确认',status: '14'}, {title: '完成', status: '9'}, {title: '取消', status: '98,99,100'},{title: '今日入住', status: 'today',value:'green'},
                {title: '入住中', status: 'stay',value:'green'},]
              case 7:
                return [{title: '全部', status: 'all'},{title: '已入住', status: '8'},{title: '完成', status: '9'}, ,{title: '待确认', status: '14'}, {
                  title: '完成',
                  status: '9'
                }, {title: '取消', status: '98,99,100'},{title: '今日入住', status: 'today',value:'green'},
                {title: '入住中', status: 'stay',value:'green'},]
              case 1:
                return [{title: '全部', status: 'all'}, {title: '待付款', status: '1'}, {
                  title: '待发货',
                  status: '2'
                }, {title: '已发货', status: '3'}]
              default:
                return []
            }
          case 3:
            //集团订单
            if(this.isGroup){
              return [
                {title: '待入住', status: '7',value:'Orange'},
                {title: '已入住', status: '8'},
                {title: '完成', status: '9'},
                {title: '今日入住', status: 'today',value:'green'},
              ]
            }
            //正常用户
            return [
              {title: '全部', status: 'all'},
              {title: '今日入住', status: 'today',value:'green'},
              {title: '入住中', status: 'stay',value:'green'},
              // {title: '已报价', status: '1', value:'red'},
              {title: '待入住', status: '7',value:'Orange'},
              {title: '已入住', status: '8'},
              {title: '完成', status: '9'},
              {title: '取消',status: '97,99'},
              ]
          case 5:
          case 8:
            return [{title: '全部', status: 'all'}, {title: this.storeInfo.type == 8 ? '待确认' :'待确认有房', status: '14'}, {
              title: '待收款',
              status: '7,8'
            }, {title: '完成', status: '9'}, {title: '取消', status: 'in_98,99,100'}, {title: '今日入住', status: 'current'},]
          case 6:
            return [{title: '全部', status: 'all'}, {title: '待确认', status: '14'}, {
              title: '完成',
              status: '6,8,9'
            }, {title: '取消', status: '99,100'}, {title: '今日入住', status: 'current'},]
          case 7:
            return [{title: '全部', status: 'all'}, {title: '待确认', status: '14'}, {
              title: '完成',
              status: '9'
            }, {title: '取消', status: '98,99,100'}]
          default:
            return []
        }
      },
      titleArr() {
        let arr = [
            {title: '团号/酒店', w: 'w-20'}, 
            {title: '订单类型', w: 'w-10'}, 
            {title: '需求/报价/人数', w: 'w-30'},
            {title: '核房人', w: 'w-10'}, 
            {title: '支付人', w: 'w-10'}, 
            {title: '状态', w: 'w-10'}, {title: '操作', w: 'w-10'}
        ];
        // if (this.userInfo.type === 2) {
        //   arr = [{title: '团号/酒店', w: 'w-20'}, {title: '入住/离店', w: 'w-20'}, 
        //   {title: '人数', w: 'w-10'}, {title: '单价', w: 'w-10'},{title: '导游/领队', w: 'w-10'}, 
        //   {title: '总额 / 已付', w: 'w-10'}, {title: '订单状态', w: 'w-10'}, {title: '操作', w: 'w-10'}];
        //   if (this.isGroup) arr.splice(1, 0, {title: '发单采购商', w: 'w-20'})
        // };
        // if (this.userInfo.type === 3) {
        //   arr = [{title: '团号 / 采购商', w: 'w-20'}, {title: '入住/离店', w: 'w-20'}, {
        //     title: '入住人数', w: 'w-10'}, {title: '发单时间 / 订单类型', w: 'w-10'}, {title: '导游/领队', w: 'w-10'},
        //     {title: '总额 / 已付', w: 'w-10'}, {title: '订单状态', w: 'w-10'}, {title: '操作', w: 'w-10'}
        //   ];
        //   if (this.isGroup) arr.splice(1, 0, {title: '匹配酒店', w: 'w-20'})
        // }
        // if (this.isAdmin) {
        //   arr = [{title: '团号/订单号/采购商', w: 'w-20'}, {title: '入住/离店', w: 'w-20'}, 
        //   {title: '人数/房型/酒店', w: 'w-10'}, {title: '订单类型/发单时间', w: 'w-10'},{title: '导游/领队', w: 'w-10'}, 
        //   {title: '总额/已付', w: 'w-10'}, {title: '订单状态', w: 'w-10'}, {title: '操作', w: 'w-10'}]
        // };
        return arr;
      },
      titleMArr() {
        let marr = ['订单号/预订单位','入住/离店','下单时间','总额/已付','导游/领队','订单状态','操作']
        if (this.isGroup) {marr.splice(1, 0, '所选门店')}
        return marr
      },
      titleSArr() {
        let sarr = ['订单号/预订单位','出行日期','订单类型/种类','下单时间','导游/领队','总额/已付','订单状态','操作']
        if (this.isGroup) {sarr.splice(1,0,'所选门店')}
        return sarr
      },
      titleBArr() {
        let barr = [{title: '订单号/品牌馆名称', w: 'w-20'},{title: '出行日期', w: 'w-10'},{title: '订单类型', w: 'w-30'},
            {title: '总额/已付', w: 'w-20'},{title: '订单状态', w: 'w-20'},{title: '操作', w: 'w-10'}]
        return barr
      },
      //是否显示酒店报价列表-采购商、管理员
      showOfferLists() {
        let t = this.storeInfo.type;
        let s = this.OrderDetail.status;
        let ss = [2, 10];
        return (t === 2 || t === 99) && !this.$GFUN.isInArray(ss, s);
      },
      //酒店查看自己的报价信息
      showHotelSelfOffer() {
        let s = [21, 22, 23, 24, 25, 13, 14, 7, 8, 9];
        return this.storeInfo.type === 3 && this.$GFUN.isInArray(s, this.cardItem.status);
      },
      //整理酒店查看的报价信息
      hotelOffer() {
        let {hotel_offer, deposit, remark} = this.OrderDetail;
        return {
          offer_time: hotel_offer ? hotel_offer[0].offer_time : '',
          totalPrice: this.OrderDetail.price,
          teaBreakPrice: this.OrderDetail.tea_break_price,
          mealPrice: this.OrderDetail.meal_price,
          status: this.OrderDetail.status,
          deposit,
          remark,
          order_price_details: {
            book_price: this.OrderDetail.deposit,
            book_pay: this.OrderDetail.deposit_pay,
            total_price: this.OrderDetail.price,
            total_pay: this.OrderDetail.price_pay,
            continued_price: this.OrderDetail.continued_price,
            continued_pay: this.OrderDetail.continued_pay,
          },
          pay_list: this.OrderDetail.payArr,
          hotel_offer: hotel_offer ? hotel_offer.map(v => {
            return {
              RoomName: v.room_meeting_name,
              HRoomPrice: v.room_num > 0 ? (v.room_price / v.room_num).toFixed(2) : '0.00',
              HRoomNum: v.room_num,
              TRoomPrice: v.travel_num > 0 ? (v.travel_room_price / v.travel_num).toFixed(2) : '0.00',
              TRoomNum: v.travel_num,
              HMeetPrice: v.meeting_price,
              HProjectorPrice: v.projector_price,
              HLedPrice: v.led_price,
              TMeetPrice: v.travel_meeting_price,
              TProjectorPrice: v.travel_projector_price,
              TLedPrice: v.travel_led_price,
              style: v.room_meetimg_style,
              type: v.order_room_meeting_type,
              needProjector: Number(v.projector) === 2,
              needLed: Number(v.led) === 2,
            }
          }) : [],
        }
      },
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['cancellationDelOrderHotel','restoreOrder','tGetOrderLists', 'hGetOrderLists', 'aGetOrderLists', 'homeGetOrderLists', 'scenicGetOrderLists', 'brandGetOrderLists', 'searchOrder', 'GetOrderDetail', 'GetOfferMess', 'getOrderNumInfo','getWaitHandleData']),
      handleClick(tab, event) {
        let text=event.target.innerText;
        if(text.indexOf('回到订单列表')!==-1){
          this.$router.go(-1); 
        }else{
        }
      },
      /**
       * 批量还原
       */
      batchRestoreOrders(){
        let res = (() => {
        if (this.hoid_list.length==0)  return { code: false, msg: '请选择要还原的订单' }
        return { code: true, msg: '验证通过' }
        })();
        if (res.code){
          let hoid_list=this.hoid_list.join(',');
          console.log(hoid_list);
          this._confirm('确定要还原该订单吗？',() => {
            this.restoreOrder({
              oid:hoid_list,
              switchs:1,
              successFun: () => {
                  this.loading = true;
                  this.getOrderList();
                  this._alert('还原订单成功');
              }
            });
          });
        }
        else this._alert(res.msg, null, 'error');
      },
      /**
       * 批量永久删除
       */
      batchDelOrderHotel(){
        let res = (() => {
        if (this.hoid_list.length==0)  return { code: false, msg: '请选择要永久删除的订单' }
        return { code: true, msg: '验证通过' }
        })();
        if (res.code){
          let hoid_list=this.hoid_list.join(',');
          console.log(hoid_list);
          this._confirm('确定要永久删除该订单吗？',() => {
            this.cancellationDelOrderHotel({
              oid:hoid_list,
              orderStatus:this.orderStatus,
              successFun: () => {
                  this.loading = true;
                  this.getOrderList();
                  this._alert('删除订单成功');
              }
            });
          });
        }
        else this._alert(res.msg, null, 'error');
      },
      /**
       * 全选
      */
      handleCheckAllChange(val) {
        if(val){
          for(let i in this.OrderLists){
              this.hoid_list.push(this.OrderLists[i].oid);
          }
        }else{
          this.hoid_list =[]
        }
        this.isIndeterminate = false;
      },
      //单选
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.OrderLists.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.OrderLists .length;
      },
      /*开始标记*/
      getOrderFlag(e,type){
        console.log(type);
        this.flagtype=type;
        this.flagtiem=e;
        this.showConfirmPanel=true;
      },
      /*排序*/
      Sort(){
        if(this.Sorts!=2){
          this.Sorts++
        }else{
          this.Sorts=0
        }
        this.loading = true;
        this.getOrderList()
      },
      /*获取订单列表*/
      getOrderList: debounce(function(clearIndex = false) {
        if (clearIndex) this.showDetailIndex = '';
        console.log(this.Hote_list);
        if (this.searchCon) {
          let data = {
            uid:this.storeInfo.type===3?this.Hote_list:this.user_list,
            type:this.storeInfo.type,
            status: this.orderStatus,
            order_date_in:this.Sorts,
            ...this.searchCon,
          }
          this.searchOrder({data:data,successFun:()=>{this.loading = false}})
        } else {
          let data = {
                uid:this.storeInfo.type===3?this.Hote_list:this.user_list,
                type:this.storeInfo.type,
                status: this.orderStatus,
                order_date_in:this.Sorts,
                ...this.searchCon,
          }
          switch (this.storeInfo.type) {
            case 2:
              this.searchOrder({data,successFun:()=>{this.loading = false}})
              break;
            case 3:
              this.hGetOrderLists({data,successFun:()=>{this.loading = false}});
              break;
            case 5:
              this.homeGetOrderLists(data);
              break;
            case 6:
              this.scenicGetOrderLists(data);
              break;
            case 8:
              this.brandGetOrderLists(data);
              break;
            case 99:
              this.aGetOrderLists({
                type: this.orderType,
                data,successFun:()=>{this.loading = false}
              });
              break;
          }
        }
      },500),
      /*跳转查看订单详情页*/
      goForDetail(cardItem) {
        console.log(this.storeInfo);
        let routeUrl = this.$router.resolve({
          name: 'OrderDetail',
          query: {
            orderType: this.orderType,
            orderId: cardItem.oid,
            match_store_id:this.storeInfo.storeId,
          }
        });
        // this.$router.push({
        //   name: 'OrderDetail',
        //   query: {
        //     orderType: this.orderType,
        //     orderId: cardItem.oid,
        //     storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
        //     status: cardItem.status|| cardItem.offer_status,
        //     GST: this.isGroup ? (cardItem.store_name || cardItem.appoint_name || cardItem.company) : ''
        //   }
        // });
        window.open(routeUrl.href, '_blank');
      },
      /*查看住宿订单的部分详情页*/
      async showDetail(cardItem, index) {
        this.cardItem = cardItem;
        this.showDetailIndex = this.showDetailIndex === index ? '' : index;
        if (this.showDetailIndex + '') {   //展开时才调取接口，收起时不调
          if (this.isAdmin || this.isGroup) this.UPDATECURRENTSTORE({storeId: cardItem.store_id})
          this.GetOrderDetail(this.cardItem.oid)
          // if (this.userInfo.type === 2) this.GetOfferMess(this.cardItem.id);
        }
      },
      /*根据条件搜索订单*/
      getSearchCon(con) {
        this.searchCon = con;
        this.showDetailIndex = '';
        if (this.queryCon.page == 1) {this.loading = true;this.getOrderList()}
        else {
          this.$router.push({
            name: this.$route.query.name,
            query: {...this.queryCon, page: 1}
          })
        };
      },
      //显示待处理订单
      showUnread(item) {
        switch (this.userInfo.type) {
          case 99:
            switch (item.title) {
              case '询价中':
                return this.OrderNumInfo.status_4;
              case '待入住':
                return this.OrderNumInfo.status_7;
              case '已入住':
                return this.OrderNumInfo.status_8;
              case '完成':
                return this.OrderNumInfo.status_9;
              case '今日入住':
                return this.OrderNumInfo.status_today;
              case '入住中':
                return this.OrderNumInfo.status_stay;
              default:
                return 0;
          }
          case 2:
            switch (item.title) {
              case '询价中':
                return this.OrderNumInfo.status_4;
              case '待入住':
                return this.OrderNumInfo.status_7;
              case '已入住':
                return this.OrderNumInfo.status_8;
              case '完成':
                return this.OrderNumInfo.status_9;
              case '今日入住':
                return this.OrderNumInfo.status_today;
              case '入住中':
               return this.OrderNumInfo.status_stay;
              default:
                return 0;
          }
          case 3: 
            switch (item.title) {
              case '待报价':
                return this.OrderNumInfo.status_1;
              case '已报价':
                return this.OrderNumInfo.status_4;
              case '待入住':
                return this.OrderNumInfo.status_7;
              case '已入住':
                return this.OrderNumInfo.status_8;
              case '完成':
                return this.OrderNumInfo.status_9;
              case '今日入住':
                return this.OrderNumInfo.status_today;
              case '入住中':
                return this.OrderNumInfo.status_stay;
              default:
                return 0;
          }
          // case 3:
          //   return item.title === '待报价' ? this.OrderNumInfo.no_offer : 0;
          // case 5:
          //   return item.title === '待确认有房' ? this.OrderNumInfo.no_check : 0;
          // case 6:
          //   return item.title === '待确认' ? this.OrderNumInfo.no_check : 0;
          // case 7:
          // case 8:
          //   return item.title === '待确认' ? this.OrderNumInfo.no_check : 0;
          // case 7:
          //   return item.title === '今日入住' ? this.OrderNumInfo.to_day : 0;
          // case 2:
          //   return item.title === '待付款' ? this.OrderNumInfo.no_pay : 0;
          default:
            return 0;
        }
      },
      //显示相应状态的订单数量
      OrderNum(item) {
        let showArr = [], showItem = null, num = 0;
        switch (this.userInfo.type) {
          case 2:
            showArr = [
            {title: '待确认', value: 'no_check'}, 
            {title: '待审核', value: 'no_verify'}, 
            {title: '询价中',value: 'inquiry'}, 
            {title: '今日入住', value: 'to_day'}, 
            {title: '待发货', value: 'no_delivery'},];
            break;
          case 3:
            showArr = [{title: '询价中', value: 'inquiry'}, {title: '待确认有房', value: 'no_check'}, {
              title: '待收款',
              value: 'no_pay'
            }, {title: '今日入住', value: 'to_day'}];
            break;
          case 5:
          case 8:
            showArr = [{title: '待收款', value: 'no_pay'}, {title: '今日入住', value: 'to_day'}];
            break;
          case 6:
            showArr = [{title: '今日入住', value: 'to_day'}];
            break;
          case 99:
            showArr = [{title: '询价中', value: 'inquiry'}, {title: '待付款', value: 'no_pay'}, {
              title: '今日入住',
              value: 'to_day'
            }];
        }
        showItem = showArr.filter(v => v.title === item.title)[0];
        num = showItem ? this.OrderNumInfo[showItem.value] : 0;
        return num;
      },
    }
  }
</script>
<style lang="scss" scoped>
  .lfts{
    float: right;
  }
  .tablie{
    background-color: #fff;
    border: 1px solid #EBF0F6;
  }
  .mop-none{
    background-color: #fff;
    margin-top: -1px;
    padding-top: 40px !important;
  }
  .d-end-start{
    justify-content:space-between;
  }
  .d-end-start .el-tabs{
    background-color: #fff;
  }
  .load-areas{
    padding: 20px 30px;
    min-height: calc(75vh);
  }
  .select-type {
    width: 150px;
    margin-right: 20px;
    margin-right: auto;
  }
  .select-types {
    width: 200px;
    margin-right: 20px;
    margin-right: auto;
  }
  .order-list-item {
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 10px 20px;
    margin-top: 15px;
    text-align: left;
  }

  .unread-msg {
    top: 0;
    right: 3px;
    left: auto;
  }
  .img-i {
    width: 15px;
    height: 15px;
    margin-right: 6px;
    cursor: pointer;
  }
  .liss{
    margin-left: 20px;
  }
  .grey{
    background: #919191;
  }
  .red{
    background: #dc3545;
  }
  .Orange{
    background: #ffa800;
  }
  .green{
    background: #09af09;
  }
  .pagination{
    background-color: #fff;
    padding:12px 0;
    overflow: hidden;
  }
  .delete{
    display: flex;
    justify-content: left;
    margin-top: 16px;
  }
  .delete p{
    background-color: #fff;
    color: #333;
    border: 1px #b4b4b4 solid;
    padding: 2px 6px;
    font-size: 12px;
    margin-left: 8px;
    margin-top: -2px;
    border-radius: 2px;
    cursor: pointer;
  }
  .cursor{
    cursor: pointer;
  }
  .jzk{
    width: 100%;
    min-height: 300px;
  }
</style>
